import type { TextFieldProps as InputProps } from '@mui/material/TextField';

import { Input } from '../Input/index.js';

export const TextArea = (props: InputProps) => {
  return <Input rows={3} multiline {...props} />;
};
